import Home from "./home/home";
import Infos from "./infos/infos";
import Formations from "./formations/formations";
import './sideText.scss';
import Experiences from "./experiences/experiences";
import LangueLoisir from "./langueLoisir/langueLoisir";
import Competences from "./competences/competences";
import Projets from "./projets/projets";
import Contact from "./contact/contact";
function SideText(){

return(
    <div className="right">
        <Home/>
        <hr/>
        <Infos/>
        <hr/>
        <Experiences/>
        <hr/>
        <Competences/>
        <hr/>
        <Projets/>
        <hr/>
        <Formations/>
        <hr/>
        <LangueLoisir/>
        <hr/>
        <Contact/>


    </div>

)
}

export default SideText;